export class PaymentAction {
  Id: string;
  CompanyId: number;
  CompanyName: string | null;
  CompanySlug: string | null;
  Slug: string;
  SlugSuggestion: string;
  Title: string;
  Description: string;
  RemittanceInformation: string;
  CreatedAt: Date;
  LastChangedAt: Date;
  PredefinedAmounts: string;
  PredefinedAmountsArray: number[];
  AllowCustomAmount: boolean;
  PaidAmount: number;
  HasPaid: boolean;
  CurrencyCode: string;

  constructor(
    id?: string,
    companyId?: number,
    companyName?: string | null,
    companySlug?: string | null,
    slug?: string,
    title?: string,
    description?: string,
    remittanceInformation?: string,
    createdAt?: Date,
    lastChangedAt?: Date,
    predefinedAmounts?: string,
    predefinedAmountsArray?: number[],
    allowCustomAmount?: boolean,
    paidAmount?: number,
    hasPaid?: boolean,
    currencyCode?: string
  ) {
    this.Id = id || null;
    this.CompanyId = companyId || null;
    this.CompanyName = companyName || null;
    this.CompanySlug = companySlug || null;
    this.Slug = slug || null;
    this.SlugSuggestion = null;
    this.Title = title || null;
    this.Description = description || null;
    this.RemittanceInformation = remittanceInformation || null;
    this.CreatedAt = createdAt || null;
    this.LastChangedAt = lastChangedAt || null;
    this.PredefinedAmounts = predefinedAmounts || '[]';
    this.PredefinedAmountsArray = predefinedAmountsArray || [];
    this.AllowCustomAmount = allowCustomAmount ?? false;
    this.PaidAmount = paidAmount || 0;
    this.HasPaid = hasPaid ?? false;
    this.CurrencyCode = currencyCode || 'EUR';
  }
}

export let PaymentActionIgnoreList: any[] = [
  'Id',
  'CreatedAt',
  'LastChangedAt',
  'CompanyId',
  'CompanyName',
  'CompanySlug',
  // Presentation only: the derived default offered in the slug field. The value actually submitted is Slug.
  'SlugSuggestion'
];
